// extracted by mini-css-extract-plugin
export default {"switchBarWrapper":"SwitchBar_switchBarWrapper__q+i0n","switchBar":"SwitchBar_switchBar__azErB","item":"SwitchBar_item__wwOzA","active":"SwitchBar_active__J45uY"};